import { io } from "socket.io-client";

// The server only sends orders and table updates to logged-in staff, so the
// login token goes with every (re)connect.
const socket = io(process.env.REACT_APP_API_BASE, {
  transports: ["websocket"],
  autoConnect: true,
  auth: (cb) => cb({ token: localStorage.getItem("token") || "" }),
});

// Call after login or logout so the server sees the new login
export const reconnectSocket = () => {
  socket.disconnect();
  socket.connect();
};

export default socket;
